/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import GenericChartVisualization from './GenericChartVisualization';
import chartHelpers from './util/helpers';

export default class DualOrMultiAxisChartVisualization extends GenericChartVisualization {

    seriesType :string = ''

    getChartSection() {
        const chart = super.getChartSection();

        return {
            ...chart,
            type: ''
        };
    }

    getTooltipSection(): any {
        const tooltip = super.getTooltipSection();

        return {
            ...tooltip,
            followPointer: true,
            shared: true
        }
    }

    getXAxisSection(selectedRowIndex: number) {
        const section = super.getXAxisSection(selectedRowIndex);

        return {
            ...section,
            categories: this.getCategoriesTree(selectedRowIndex)
        }
    }

    getYAxisSection() {
        let yAxis = super.getYAxisSection();

        yAxis = chartHelpers.yAxisTickAdjust(yAxis, this.getRecordedMinMaxValues());

        return yAxis;
    }
}
